import React from 'react';

//Bootstrap
import { Row, Col } from 'react-bootstrap';

import { faFacebookF, faWhatsapp, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

import SocialButton from './SocialButton/SocialButton';

const iconArr = [faFacebookF, faWhatsapp, faTwitter, faInstagram, faLinkedinIn];

const SocialButtons = (props) => {
    return (
        <Row className="px-4 justify-content-center text-align-center">
            <Col lg="10" xl="7">
                {props.data ? props.data.map(s => {
                    const icon = iconArr.find(i => i.iconName === decodeURIComponent(s.ICONO));
                    return <SocialButton key={s.ID} href={decodeURIComponent(s.VALOR)} icon={icon} title={decodeURIComponent(s.NOMBRE)}/>
                }) : null}
            </Col>
        </Row>
    );
};

export default SocialButtons;